import { render, staticRenderFns } from "./GlicemiaCapilar.vue?vue&type=template&id=667e656e&"
import script from "./GlicemiaCapilar.vue?vue&type=script&lang=js&"
export * from "./GlicemiaCapilar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports